import { createTheme } from '@mui/material/styles';

export const brand = {
  50: '#F9D8CF',
  100: '#F5B5A7',
  200: '#F28E7D',
  300: '#EF6A58',
  400: '#F05436', // Main brand color
  500: '#D84B31',
  600: '#BE412B',
  700: '#A23824',
  800: '#852E1D',
  900: '#682416',
};

// Warm light surfaces, tinted towards the brand rather than neutral grey.
export const surface = {
  default: '#FFF9F7',
  paper: '#FFFFFF',
  raised: '#FDEDE8',
  border: 'rgba(0, 0, 0, 0.12)',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: brand[200],
      main: brand[400],
      dark: brand[700],
      contrastText: '#fff',
    },
    background: {
      default: surface.default,
      paper: surface.paper,
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    divider: surface.border,
  },
  shape: { borderRadius: 8 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: surface.default },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: 0,
          paddingTop: 10,
          paddingBottom: 10,
        },
        containedPrimary: {
          '&:hover': { backgroundColor: brand[500] },
        },
      },
    },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
  },
});

export default theme;
